export default __webpack_public_path__ + "static/media/MATIC.71ea3f4b.png";